<template>
   <cc-container>
      <cc-header-nav
        class="header"
        title="医保专区">
         <template slot="right">
            <div class="search-wrap" @click.stop="openSearch">
               <cc-svg-icon
                 icon-class="search"
                 class-name="search-icon"
               ></cc-svg-icon>
            </div>
            <div  class="ellipsis">
               <van-icon
                 class="ellipsis-icon"
                 name="ellipsis"
                 @click.stop="isShowSmallNav = !isShowSmallNav"
               />
            </div>
         </template>
      </cc-header-nav>
      <cc-main class="main" :style="{background:`#${ad && ad.background_color}`}">
         <cc-pull-refresh  v-model="isLoading" @refresh="onRefresh">
           <!-- <div class="banner" @click="toPage(ad)" v-show="!isLoading"> -->
           <div class="banner" @click="toPage(ad)" >
              <img
                :src="(ad && ad.image) || require(`@/assets/img/home/medical_banner.png`)"                         v-errorImg="require(`@/assets/img/home/medical_banner.png`)" alt="">
           </div>
            <not-goods  v-if="list.length === 0 && m_loading === false"></not-goods>
           <van-list
             v-else
             class="goods-list"
             @click.stop
             v-model="m_loading"
             :finished="m_finished"
             :finished-text="m_finishedText"
             @load="mHandlePullUpLoadMore"
             :immediate-check="m_immediateCheck"
           >
              <goods-item
                v-for="(item,index) in list"
                :item="item"
                :key="index"
              >
              </goods-item>
           </van-list>
          </cc-pull-refresh>
      </cc-main>
      <cc-small-nav v-model="isShowSmallNav"/>
      <search-overlay
        :show="showSearch"
        @cacel="showSearch=false"
      >
      </search-overlay>
   </cc-container>
</template>

<script>
import Vue from 'vue'
import CartStepMixin from '@/mixins/cartStep'
import CommandMixin from '@/mixins/command'
import ListMixin from '@/mixins/list'
import { Icon, List } from 'vant'
import GoodsItem from './item'
import { loadMedicareData } from '../../../fetch/home/medicare'
import SearchOverlay from './search-overlay'
import NotGoods from '../components/not-goods'
Vue.use(Icon)
  .use(List)
export default {
  name: 'medical-insurance',
  mixins: [ListMixin, CartStepMixin, CommandMixin],
  components: {
    NotGoods,
    GoodsItem,
    SearchOverlay
  },
  data () {
    return {
      list: [],
      searchList: [],
      ad: {},
      isLoading: false,
      productName: '',
      showSearch: false,
      isShowSmallNav: false
    }
  },
  computed: {
    getBanner () {
      if (this.ad.image) {
        return this.ad.image
      } else {
        return require(`@/assets/img/home/medical_banner.png`)
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    onRefresh () {
      this.mReset()
      // this.list = []
      this.loadData(true)
    },
    openSearch () {
      this.showSearch = true
      this.isShowSmallNav = false
    },
    async loadData (reset) {
      this.mRequest()
      const params = {
        page: this.m_page.curr,
        page_size: this.m_page.limit,
        second_keyword: this.productName
      }
      let res = await loadMedicareData(params)
      this.$tips(res, {
        tip: false
      }, res => {
        this.isLoading = false
        const data = res
        this.ad = data.ad
        if (data.models.length === 0) {
          if (reset) {
            this.list = []
          }
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          this.list = reset ? data.models : [...this.list, ...data.models]
          this.addGoodField(this.list)
        }
      })
      this.mSuccess()
    },
    toPage (ad) {
      if (ad) {
        location.href = ad.url
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
   /deep/ {
      background: #ffffff!important;
      color:#333333!important;
      .left-arrow{
         color:#333333!important;
      }
   }
   .search-wrap{
      width: 24px;
      transform: translateX(-5px);
   }
   .search-icon{
      color: #333333;
   }
}
.banner{
   height: 130px;
   width: 100%;
   img{
      height: 100%;
      width: 100%;
   }
}
.goods{
   padding: 10px;
}
.goods-list{
   padding: 10px;
}
.ellipsis{
   width: 50%;
   height: 100%;
   @include center();
   transform: translateX(-5px);
   &-icon{
      transform: rotate(90deg);
   }
}
</style>
